import { formatSizeUnits } from './BytesToMo'

export const getSizeFromDocument = (document, isImage) => {

  if(isImage) {
    if(document.cloudinaryAsset?.length > 0) {
      const size = formatSizeUnits(document.cloudinaryAsset[0].bytes)
      const format = document.cloudinaryAsset[0].format
      return (format ? format?.toUpperCase() + ' - ' : '') + size
    } else {
      return null
    }

  }

  if (document.cloudinary) {
    const size = formatSizeUnits(document.cloudinary[0].bytes)
    const format = document.cloudinary[0].format
    return (format ? format?.toUpperCase() + ' - ' : '') + size
  } else if (document.contentfulAsset) {
    const size =
      formatSizeUnits(document.contentfulAsset.file?.details.size) ||
      document.contentfulAsset.fields.file.contentType
    const str =
      document.contentfulAsset.file?.contentType ||
      document.contentfulAsset.fields.file.contentType ||
      ''
    const a = str.split('/')
    return a[1].toUpperCase() + ' - ' + size
  }
  return ''
}
